import React from "react";
const StandAloneFooter = () => {
  return (
    <footer className="d-footer  py-3  border-top ">
      <div className="">
        <div className="row align-items-center justify-content-between">
          {/* Copyright Text */}
          <div className="col-auto ">
            <p className="mb-0 text-muted text-sm ">
              © {new Date().getFullYear()} GIS Lab. All Rights Reserved.
            </p>
          </div>

          {/* Developer Credit */}
          <div className="col-auto">
            <p className="mb-0 text-muted text-sm">
              Developed by{" "}
              <span className="text-success-600 fw-semibold">
                GIS Lab | Forest Department Lahore
              </span>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default StandAloneFooter;
